<template>
  <div>
    <van-popup v-model="visible" class="HideScrollbar" :close-on-click-overlay="false"
      :style="{ width: '360px', height: '160px' }">
      <div class="main">
        <!-- {{sPotype }} -->
        <div v-if="checktype == 'mobile'">
          <van-field v-model="phone" type="tel" label="手機號碼" placeholder="Your Phone Number" size="large"
            show-word-limit clickable maxlength="10" @touchstart.stop="showKB = true" />
        </div>

        <div v-if="checktype == 'tblname'">
          <van-field v-model="phone" type="texxt" label="您的桌號" placeholder="Your Table Name" size="large"
            show-word-limit clickable maxlength="10" @touchstart.stop="showKB = true" />
        </div>

        <div v-if="checktype == 'random'">
          <van-field v-model="phone" type="tel" label="亂數號碼" placeholder="Your Random Number" size="large"
            show-word-limit clickable maxlength="10" @touchstart.stop="showKB = true" />
        </div>


        <!-- <van-number-keyboard
          v-model="phone"
          theme="custom"
          :extra-key="['09']"
          :show="true"
          :maxlength="10"
          close-button-text="確認"
          @close="cmdStart()"
        /> -->
      </div>

      <Footer b1="確認" :anime="checkInput()" @b1c="cmdStart()" />
      <!-- <Footer :b1="btnCarText()" :anime="checkInput()" @b1c="cmdStart()" /> -->
    </van-popup>
  </div>
</template>
<style scoped>
.van-popup,
.main {
  width: 360px;
  line-height: 2rem;
}

.van-field {
  margin-top: 1rem;
}

.container {
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tip {
  position: fixed;
  left: 50%;
  bottom: 0rem;
  transform: translate(-50%, -50%);
}

.van-image {
  padding: 0;
  margin: 0;
}
</style>
<script>
var fits = require("../../../mixin/lib-fits-front");
import qs from "qs";
export default {
  data() {
    return {
      visible: false,
      anime: true,
      phone: "",
      showKB: false,
      checktype: "mobile",
    };
  },
  mounted() {
  },
  methods: {
    async cmdStart() {
      if (!this.checkInput()) return false;
      // 1.使用者/用餐方式
      this.$store.commit("setUser", this.phone);
      if (!this.sGetConfig("kioskMode")) {
        sessionStorage.setItem("phone", this.phone);
      }
      console.log("cmdStart()", this.sPoH.length);
      let poLen0 = this.sPoH.length;
      if (poLen0 == 0) {
        //如果載入後，原本沒有訂單，再次查詢後有訂單=>重載頁面
        await this.gInit();
        let poLen = this.sPoH.length;
        if (poLen > 0) {
          this.gMsgbox("您有" + poLen + "筆歷史訂單")
            .then(() => {
              return (window.location.href = "/?" + qs.stringify(this.$route.query));
            })
            .catch(() => { });
        }
      }

      // console.log("s.uid", this.uid);
      this.visible = false;
      // await this.gLoadOrdertmp();
    },

    async show() {
      var phone = this.gStr(sessionStorage.getItem("phone"));
      if (this.sGetConfig("kioskMode")) phone = "";
      phone != "" && (this.phone = phone);

      this.checktype = this.sGetConfig("txtCheckFrmUser");
      if (this.checktype == "") this.checktype = "mobile";
      if (this.sPotype == "外帶") this.checktype = "mobile";
      if (this.checktype == "mobile" && this.phone.length != 10) this.phone = "";

      if (this.checktype == "random") {
        this.phone = fits.uuid().substring(0, 6);
      }
      this.visible = true;
    },

    checkInput() {
      if (this.checktype == "mobile")
        if (this.phone.length != 10) {
          return false;
        }

      if (this.checktype == "tblname" && this.phone.length == 0) return false;
      if (this.checktype == "random" && this.phone.length == 0) return false;

      return true;
    },
    btnCarText() {
      if (this.phone.length != 10) {
        return "請輸入手機 Your Phone Number";
      }

      return "開始點餐 START";
    },
  },
};
</script>
